import { createFileRoute, redirect } from "@tanstack/react-router";
const SLUG = "how-to-fix-a-leaking-roof-from-inside";
export const Route = createFileRoute("/how-to-fix-a-leaking-roof-from-inside")({
  beforeLoad: () => { throw redirect({ to: "/blog/$slug", params: { slug: SLUG }, statusCode: 301 }); },
});
